import { Card, Checkbox, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { trueOrFalseEnum } from "utils/Enums";
import { cleanFormatCNPJ, verifyVariable } from "utils/Functions";
import { get, post } from "utils/WebService";
import ProcessCreateEdit from "./ProcessCreateEdit";

export default function ProcessConsult() {

    const { processoPessoaTipo, processoStatus } = useUser();

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        empresa: "",
        cnpj: "",
        processo: "",
        advogados: null,
        analisado: null,
        inicioPeriodo: "",
        fimPeriodo: "",
        inicioPesquisa: "",
        fimPesquisa: "",
        sentenca: null,
        status: null,
        nomeTipoPessoa: "",
        execucao: null,
        tipoPessoa: null,
        casoDocumento: ""
    });

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isLoadingLawyers, setIsLoadingLawyers] = useState(false);
    const [lawyers, setLawyers] = useState([]);
    const [isLoadingSentenca, setIsLoadingSentenca] = useState(false);
    const [sentenca, setSentenca] = useState([]);

    const [filters, setFilters] = useState({
        empresa: "",
        cnpj: "",
        processo: "",
        advogados: null,
        analisado: null,
        inicioPeriodo: "",
        fimPeriodo: "",
        inicioPesquisa: "",
        fimPesquisa: "",
        sentenca: null,
        status: null,
        nomeTipoPessoa: "",
        execucao: null,
        tipoPessoa: null,
        casoDocumento: ""
    });

    const [refresh, setRefresh] = useState(false);
    const [recordsTotal, setRecordsTotal] = useState(0);

    useEffect(() => {
        fetchData(tableState.current);
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered,
        empresa,
        cnpj,
        processo,
        advogados,
        analisado,
        inicioPeriodo,
        fimPeriodo,
        inicioPesquisa,
        fimPesquisa,
        sentenca,
        status,
        nomeTipoPessoa,
        execucao,
        tipoPessoa,
        casoDocumento
    }) => {
        setLoadingTable(true);

        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
            empresa: empresa ? empresa : tableState.current.empresa,
            cnpj: cnpj ? cnpj : tableState.current.cnpj,
            processo: processo ? processo : tableState.current.processo,
            advogados: advogados ? advogados : tableState.current.advogados,
            analisado: analisado != null ? analisado : tableState.current.analisado,
            inicioPeriodo: inicioPeriodo ? inicioPeriodo : tableState.current.inicioPeriodo,
            fimPeriodo: fimPeriodo ? fimPeriodo : tableState.current.fimPeriodo,
            inicioPesquisa: inicioPesquisa ? inicioPesquisa : tableState.current.inicioPesquisa,
            fimPesquisa: fimPesquisa ? fimPesquisa : tableState.current.fimPesquisa,
            sentenca: sentenca ? sentenca : tableState.current.sentenca,
            status: status ? status : tableState.current.status,
            nomeTipoPessoa: nomeTipoPessoa ? nomeTipoPessoa : tableState.current.nomeTipoPessoa,
            execucao: execucao != null ? execucao : tableState.current.execucao,
            tipoPessoa: tipoPessoa ? tipoPessoa : tableState.current.tipoPessoa,
            casoDocumento: casoDocumento ? casoDocumento : tableState.current.casoDocumento
        };

        tableState.current = updatedTableState;
        post("/processes/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: [],
            empresa: updatedTableState.empresa,
            cnpj: updatedTableState.cnpj,
            processo: updatedTableState.processo,
            advogados: updatedTableState.advogados,
            analisado: updatedTableState.analisado,
            inicioPeriodo: updatedTableState.inicioPeriodo,
            fimPeriodo: updatedTableState.fimPeriodo,
            inicioPesquisa: updatedTableState.inicioPesquisa,
            fimPesquisa: updatedTableState.fimPesquisa,
            sentenca: updatedTableState.sentenca,
            status: updatedTableState.status,
            nomeTipoPessoa: updatedTableState.nomeTipoPessoa,
            execucao: updatedTableState.execucao,
            tipoPessoa: updatedTableState.tipoPessoa,
            casoDocumento: updatedTableState.casoDocumento
        }).then(({ data, pages, recordsTotal }) => {
            setPages(pages);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
        }).catch(() => setLoadingTable(false));

        setRefresh(false);

    }, [refresh]);

    useEffect(() => {
        handleSearchLawyers(null);
        handleSearchSentenca(null);
    }, []);

    function handleSearchLawyers(value) {
        setIsLoadingLawyers(true);
        let search = verifyVariable(value) ? `?search=${value}` : "";
        get(`/lawyer/list-all${search}`)
            .then(({ list }) => {
                setLawyers(list);
                setIsLoadingLawyers(false);
            }).catch(() => {
                setLawyers([]);
                setIsLoadingLawyers(false);
            });
    }

    function handleSearchSentenca(value) {
        setIsLoadingSentenca(true);
        let search = verifyVariable(value) ? `?search=${value}` : "";
        get(`/processes/sentence/list-all${search}`)
            .then(({ list }) => {
                setSentenca(list);
                setIsLoadingSentenca(false);
            }).catch(() => {
                setSentenca([]);
                setIsLoadingSentenca(false);
            });
    }

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
    }

    const handleRefresh = () => {
        setRefresh(true);
    };

    const userColumns = [
        {
            header: "empresa",
            accessorKey: "empresa",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "cnpj",
            accessorKey: "cnpj",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Nº processo",
            accessorKey: "numeroProcesso",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Status",
            accessorKey: "status",
            cell: info => <DefaultCell>{processoStatus.find(ht => ht.code === info.getValue())?.name || "-"}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Analisado",
            accessorKey: "analisado",
            cell: info => (
                <Checkbox
                    checked={info.getValue()}
                    disabled
                    color="primary"
                    inputProps={{ 'aria-label': 'Analisado' }}
                />
            ),
            isSorted: false
        },
        {
            header: "Sentença",
            accessorKey: "sentenca",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Editar Advogado">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original.id);
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>edit</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "10%"
        },
    ];

    const handleApplyFilter = () => {
        fetchData({
            ...tableState.current,
            empresa: filters.empresa,
            cnpj: cleanFormatCNPJ(filters.cnpj),
            processo: cleanFormatCNPJ(filters.processo),
            advogados: filters.advogados?.map(advogado => advogado.id),
            analisado: filters.analisado,
            inicioPeriodo: filters.inicioPeriodo,
            fimPeriodo: filters.fimPeriodo,
            inicioPesquisa: filters.inicioPesquisa,
            fimPesquisa: filters.fimPesquisa,
            sentenca: filters.sentenca?.map(sentenca => sentenca.name),
            status: filters.status?.id,
            nomeTipoPessoa: filters.nomeTipoPessoa,
            execucao: filters.execucao,
            tipoPessoa: filters.tipoPessoa?.id,
            casoDocumento: cleanFormatCNPJ(filters.casoDocumento),
            pageIndex: 0 // Resetar para primeira página ao filtrar
        });
    };

    const handleCleanFilter = () => {
        setFilters({
            empresa: "",
            cnpj: "",
            processo: "",
            advogados: null,
            analisado: null,
            inicioPeriodo: "",
            fimPeriodo: "",
            inicioPesquisa: "",
            fimPesquisa: "",
            sentenca: null,
            status: null,
            nomeTipoPessoa: "",
            execucao: null,
            tipoPessoa: null,
            casoDocumento: ""
        });
        const updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            empresa: "",
            cnpj: "",
            processo: "",
            advogados: null,
            analisado: null,
            inicioPeriodo: "",
            fimPeriodo: "",
            inicioPesquisa: "",
            fimPesquisa: "",
            sentenca: null,
            status: null,
            nomeTipoPessoa: "",
            execucao: null,
            tipoPessoa: null,
            casoDocumento: ""
        };

        tableState.current = updatedTableState;
        fetchData(updatedTableState);
    };

    return (
        <Grid container display="flex" justifyContent="center">
            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <ProcessCreateEdit
                        processId={selectedId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh} />
                </Grid>
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? "#4B4F5C" : "#fafafa",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <Grid container spacing={1}>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Empresa</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe a empresa..."
                                    value={filters.empresa ?? ""}
                                    onChange={({ target }) => setFilters({ ...filters, empresa: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>CNPJ</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o cnpj..."
                                    value={filters.cnpj ?? ""}
                                    onChange={({ target }) => setFilters({ ...filters, cnpj: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>CPF/CNPJ do Caso</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o cpf/cnpj do caso..."
                                    value={filters.casoDocumento ?? ""}
                                    onChange={({ target }) => setFilters({ ...filters, casoDocumento: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nº Processo</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o nº do processo..."
                                    value={filters.processo ?? ""}
                                    onChange={({ target }) => setFilters({ ...filters, processo: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome Tipo Pessoa</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o nome tipo pessoa..."
                                    value={filters.nomeTipoPessoa ?? ""}
                                    onChange={({ target }) => setFilters({ ...filters, nomeTipoPessoa: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Advogados</InputLabel>
                                <MDSelect
                                    loading={isLoadingLawyers}
                                    isMulti={true}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome}
                                    name="advogados"
                                    placeholder="Ambos"
                                    value={filters.advogados || null}
                                    options={lawyers}
                                    onInputChange={e => handleSearchLawyers(e)}
                                    onChange={(value) => {
                                        setFilters({ ...filters, advogados: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Analisado</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    name="analisado"
                                    placeholder="Ambos"
                                    value={trueOrFalseEnum.find(({ value }) => value == filters.analisado) || null}
                                    options={trueOrFalseEnum}
                                    onChange={({ value }) => {
                                        setFilters({ ...filters, analisado: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Execução</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    name="execucao"
                                    placeholder="Ambos"
                                    value={trueOrFalseEnum.find(({ value }) => value == filters.execucao) || null}
                                    options={trueOrFalseEnum}
                                    onChange={({ value }) => {
                                        setFilters({ ...filters, execucao: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.code}
                                    getOptionLabel={(option) => option.name}
                                    name="status"
                                    placeholder="Ambos"
                                    value={filters.status || null}
                                    options={processoStatus}
                                    onChange={(value) => {
                                        setFilters({ ...filters, status: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo Pessoa</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.code}
                                    getOptionLabel={(option) => option.name}
                                    name="tipoPessoa"
                                    placeholder="Ambos"
                                    value={filters.tipoPessoa || null}
                                    options={processoPessoaTipo}
                                    onChange={(value) => {
                                        setFilters({ ...filters, tipoPessoa: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Sentença</InputLabel>
                                <MDSelect
                                    loading={isLoadingSentenca}
                                    isMulti={true}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    name="senteca"
                                    placeholder="Ambos"
                                    value={filters.sentenca}
                                    options={sentenca}
                                    onChange={(value) => {
                                        setFilters({ ...filters, sentenca: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Início Pesquisa</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.inicioPesquisa ?? ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, inicioPesquisa: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Fim Pesquisa</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.fimPesquisa ?? ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, fimPesquisa: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Início Período</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.inicioPeriodo ?? ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, inicioPeriodo: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Fim Período</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.fimPeriodo ?? ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, fimPeriodo: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={12} display="flex" alignItems="center" justifyContent="end" pt={1}>
                                <MDBox>
                                    <MDButton
                                        size="medium"
                                        sx={{ marginRight: 2 }}
                                        variant="contained"
                                        color="info"
                                        circular={false}
                                        iconOnly={false}
                                        onClick={handleCleanFilter}>
                                        Limpar filtro
                                    </MDButton>
                                    <MDButton size="medium" variant="contained" color="info" circular={false} iconOnly={false} onClick={handleApplyFilter}>
                                        Aplicar filtro
                                    </MDButton>
                                </MDBox>
                            </Grid>
                    </Grid>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={data}
                    fetchData={fetchData}
                    totalPages={pages}
                    totalRecords={recordsTotal}
                    tableState={tableState} />
            </Grid>
        </Grid >
    );
}
